import {Component, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {COOKIE_CONSENT, getCookie} from '../config/cookies.config';

@Component({
    selector: 'app-cookie-consent-dialog',
    templateUrl: './cookie-consent-dialog.component.html',
    styleUrls: ['./cookie-consent-dialog.component.scss'],
    standalone: false
})
export class CookieConsentDialogComponent implements OnInit {
  showCookiesOptions: boolean = false;
  allNeededCookiesAccordion = false;
  googleAnalyticsCookiesAccordion = false;
  pixelFBCookiesAccordion = false;
  hotjarCookiesAccordion = false;

  googleAnalyticsCookie = false;
  hotjarCookie = false;

  private isConsented: string = '';

  constructor(private dialogRef: MatDialogRef<CookieConsentDialogComponent>) {
    this.isConsented = getCookie(COOKIE_CONSENT);
    const activeCookies =  this.isConsented.split('|');
    if (activeCookies[0]) {
      this.googleAnalyticsCookie = activeCookies[0] === '1';
    }

    if (activeCookies[1]) {
      this.hotjarCookie = activeCookies[2] === '1';
    }
  }

  ngOnInit(): void {
  }

  private setCookie() {
    const value = `${this.googleAnalyticsCookie ? '1' : '0'}` +  '|' + `${this.hotjarCookie ? '1' : '0'}`;
    let d: Date = new Date();
    d.setTime(d.getTime() + 366 * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = '';
    document.cookie = `${COOKIE_CONSENT}=${value}; ${expires}${cpath}`;
    this.dialogRef.close();
    window.location.reload();
  }

  openAccordion(event, allNeededCookiesAccordion, googleAnalyticsCookiesAccordion, pixelFBCookiesAccordion, hotjarFBCookiesAccordion) {
    if (event.target.classList.length) {
      this.allNeededCookiesAccordion = allNeededCookiesAccordion;
      this.googleAnalyticsCookiesAccordion = googleAnalyticsCookiesAccordion;
      this.pixelFBCookiesAccordion = pixelFBCookiesAccordion;
      this.hotjarCookiesAccordion = hotjarFBCookiesAccordion;
    }
  }

  acceptAllCookies() {
    this.googleAnalyticsCookie = true;
    this.hotjarCookie = true;
    this.setCookie();
  }
}

